import React, { Fragment, useContext } from "react";
import { Link, useParams } from "react-router-dom";
import MarketNavbar from "../MarketNav/MarketNavbar";
import MarketplacePage from "../components/MarketplacePage";
import ProductGrid from "../components/ProductGrid";
import QuickAddSizeModal from "../components/QuickAddSizeModal";
import ProductGridSkeleton from "../components/ProductGridSkeleton";
import Spinner from "../../../Spinner/Spinner";
import usePublicMerchantStore from "../libs/usePublicMerchantStore";
import useInfiniteScroll from "../libs/useInfiniteScroll";
import { CartContext } from "../../../Context/CartContext";
import useQuickAddToCart from "../libs/useQuickAddToCart";
import { ToastContainer } from "react-toastify";
import "../ProductCategory/ProductCategory.css";
import "../marketplace-layout.css";
import "react-toastify/dist/ReactToastify.css";

const MerchantStorefrontPage = () => {
  const { merchantId } = useParams();
  const { addItemToCart } = useContext(CartContext);
  const { quickAdd, pending, confirmSize, cancelSize } = useQuickAddToCart(addItemToCart);

  const {
    data,
    isLoading,
    isError,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
  } = usePublicMerchantStore(merchantId);

  const lastElementRef = useInfiniteScroll(fetchNextPage, hasNextPage, isFetchingNextPage);
  const storeMeta = data?.pages?.[0];
  const merchant = storeMeta?.merchant;
  const seller = storeMeta?.seller;
  const storeName =
    merchant?.businessName ||
    [seller?.firstName, seller?.lastName].filter(Boolean).join(" ") ||
    "Store";
  const hasProducts = (data?.pages || []).some((page) => (page.products || []).length > 0);

  if (isLoading) {
    return (
      <Fragment>
        <MarketNavbar />
        <MarketplacePage>
          <ProductGridSkeleton count={8} />
        </MarketplacePage>
      </Fragment>
    );
  }

  if (isError || (!merchant && !hasProducts)) {
    return (
      <Fragment>
        <MarketNavbar />
        <MarketplacePage>
          <div className="search-results-empty">
            <h2>Store not found</h2>
            <p>This seller may no longer be on the marketplace.</p>
            <Link to="/market">Back to marketplace</Link>
          </div>
        </MarketplacePage>
      </Fragment>
    );
  }

  return (
    <Fragment>
      <MarketNavbar />
      <MarketplacePage>
        <div className="merchant-storefront">
          <nav className="search-results-breadcrumb" aria-label="Breadcrumb">
            <Link to="/market">Home</Link>
            <span>/</span>
            <span>{storeName}</span>
          </nav>
          <header className="merchant-storefront__header">
            <h1>{storeName}</h1>
            {merchant?.businessDescription && (
              <p className="merchant-storefront__desc">{merchant.businessDescription}</p>
            )}
            <div className="merchant-storefront__meta">
              {merchant?.city && merchant?.state && (
                <span>
                  {merchant.city}, {merchant.state}
                </span>
              )}
              {storeMeta?.totalProducts != null && (
                <span>{storeMeta.totalProducts} product{storeMeta.totalProducts === 1 ? "" : "s"}</span>
              )}
            </div>
          </header>
          <ProductGrid
            pages={data?.pages || []}
            lastElementRef={lastElementRef}
            onAddToCart={quickAdd}
          />
          {isFetchingNextPage && (
            <div className="loading-more">
              <Spinner />
            </div>
          )}
        </div>
      </MarketplacePage>
      <QuickAddSizeModal pending={pending} onConfirm={confirmSize} onCancel={cancelSize} />
      <ToastContainer position="top-right" className="toast" />
    </Fragment>
  );
};

export default MerchantStorefrontPage;
